import { render } from "./AdminSideNav.vue?vue&type=template&id=0823cef0&scoped=true"
import script from "./AdminSideNav.vue?vue&type=script&lang=js"
export * from "./AdminSideNav.vue?vue&type=script&lang=js"

import "./AdminSideNav.vue?vue&type=style&index=0&id=0823cef0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0823cef0"]])

export default __exports__